import type { SliderProps as MuiSliderProps } from '@mui/material';
import { Slider as MuiSlider } from '@mui/material';

export type SliderProps = MuiSliderProps;

/** Sliders allow users to make selections from a range of values. https://mui.com/material-ui/react-slider/ */
export const Slider = (props: SliderProps) => <MuiSlider {...props} />;
